import type { CSSProperties } from 'react';

export type PanelFeaturePromotionBannerAccent =
  | 'seaweed'
  | 'blue'
  | 'eggplant'
  | 'green'
  | 'indigo'
  | 'neutral'
  | 'red'
  | 'rose'
  | 'tangerine'
  | 'yellow';

export const getPanelFeaturePromotionBannerAccentCssVars = (
  accent: PanelFeaturePromotionBannerAccent = 'seaweed'
): CSSProperties => {
  return {
    '--pfpb-border': `var(--fabric-color-accent-${accent}-base)`,
    '--pfpb-header-bg': `var(--fabric-color-accent-${accent}-alpha-subtle)`,
    '--pfpb-icon': `var(--fabric-color-accent-${accent}-base)`,
    '--pfpb-chip-bg': `var(--fabric-color-accent-${accent}-alpha-subtle)`,
  } as CSSProperties;
};
